import React from 'react'

import { useTranslation } from 'language/translator'
import { useAnalysis } from 'redux/hooks/Analyses'
import { useParams } from 'utils/hooks'

import {
  BreadcrumbsProps,
  TBreadcrumbItem
} from 'components_new/molecules/Breadcrumbs'

import PageLayout, {
  PageLayoutProps
} from 'components_new/templates/PageLayout'

interface AnalysisTemplateProps
  extends Omit<PageLayoutProps, 'rightSidebar' | 'topbar' | 'variant'> {
  rightSidebar?: Pick<
    NonNullable<PageLayoutProps['rightSidebar']>,
    'collapsed' | 'content' | 'setCollapsed' | 'size'
  >
  topbar?: Pick<NonNullable<PageLayoutProps['topbar']>, 'actions' | 'options'>
  subpage?: TBreadcrumbItem
}

const AnalysisTemplate = (props: AnalysisTemplateProps) => {
  const { children, rightSidebar, subpage, topbar, ...rest } = props

  const { id } = useParams()
  const { analysis } = useAnalysis(id)
  const { t } = useTranslation()

  const breadcrumbs: BreadcrumbsProps['items'] = [
    {
      href: '/analyses',
      icon: { name: 'Analyses' },
      title: t('analyses', 'analyses')
    }
  ]

  if (analysis) {
    breadcrumbs.push({
      href: `/analyses/${analysis.id}`,
      title: analysis.title
    })
  }

  if (subpage) {
    breadcrumbs.push(subpage)
  }

  return (
    <PageLayout
      rightSidebar={rightSidebar}
      topbar={{
        actions: topbar?.actions,
        options: topbar?.options,
        breadcrumbs: breadcrumbs,
        mobile: {
          goBack: true
        }
      }}
      content={{
        size: 'large'
      }}
      variant="feed"
      {...rest}
    >
      {children}
    </PageLayout>
  )
}

export default AnalysisTemplate
